import React from 'react'
import { fattPayClient } from "./FattPayClient";
import { Col, Form, Button } from 'react-bootstrap';
import Payment from './Payment';
import { deepCopy } from '../../Components/Shared/Utility/DeepCopy';
import { ValidatorHelper } from '../../Components/Shared/ValidatorHelper';

interface IFattPayCreditCardProps {
    onPaymentChanged: (payment: Payment) => void;
    payment: Payment,
    disabled?: boolean
}

const monthRegex = new RegExp('0[1-9]|1[012]');
const yearRegex = new RegExp('\\d{4}');

export const FattPayCreditCard = React.forwardRef((props: IFattPayCreditCardProps, ref: React.Ref<any>) => {
    var cardRef = React.createRef<HTMLDivElement>();
    var cvvRef = React.createRef<HTMLDivElement>();
    var ccMonthRef = React.useRef(null);
    var ccYearRef = React.useRef(null);

    React.useImperativeHandle(ref,
        () => ({
            validate(payment: Payment) : boolean {
                ValidatorHelper.clearCustomValidation(ccMonthRef.current);
                ValidatorHelper.clearCustomValidation(ccYearRef.current);
                var isValid = true;
        
                if (payment.month.match(monthRegex) === null) {
                    ValidatorHelper.setCustomValidationWithFeedback(ccMonthRef.current, "Enter 2 Digit Month.");
                    isValid = false;
                }
        
                if (payment.year.match(yearRegex) === null) {
                    ValidatorHelper.setCustomValidationWithFeedback(ccYearRef.current, "Enter 4 Digit Year.");
                    isValid = false;
                }
        
                return isValid;
            }
        }),
    );

    React.useEffect(() => {
        async function initialize() {
            //Initialize Bank
            await fattPayClient.initializeCreditCard(cardRef.current, cvvRef.current);
        }
        initialize();
    }, []);


    const updateFirstName = (firstName: string) => {
        const updated = deepCopy(props.payment);
        updated.firstName = firstName;
        props.onPaymentChanged(updated);
    }

    const updateLastName = (lastName: string) => {
        const updated = deepCopy(props.payment);
        updated.lastName = lastName;
        props.onPaymentChanged(updated);
    }

    const updateMonth = (month: string) => {
        const updated = deepCopy(props.payment);
        updated.month = month;
        props.onPaymentChanged(updated);
    }

    const updateYear = (year: string) => {
        const updated = deepCopy(props.payment);
        updated.year = year;
        props.onPaymentChanged(updated);
    }

    return (
        <React.Fragment>
            <Form.Group className="mt-4">
                <Form.Label className="font-weight-bolder mb-1 pp-font-size-smaller">Cardholder Name
                    <span className="text-pp-primary ml-2">*</span></Form.Label>
                <Form.Row>
                    <Col>
                        <Form.Control type="input" required placeholder="First" isInvalid={props.payment.error?.field === "first_name"}
                            onChange={(e) => updateFirstName(e.target.value)}
                            defaultValue={props.payment.firstName} />
                        <Form.Control.Feedback type="invalid">First Name is Required</Form.Control.Feedback>
                    </Col>
                    <Col>
                        <Form.Control type="input" required placeholder="Last" isInvalid={props.payment.error?.field === "last_name"}
                            onChange={(e) => updateLastName(e.target.value)}
                            defaultValue={props.payment.lastName} />
                        <Form.Control.Feedback type="invalid">Last Name is Required</Form.Control.Feedback>
                    </Col>
                </Form.Row>
            </Form.Group>
            <Form.Group className="mt-4">
                <Form.Label className="font-weight-bolder mb-1 pp-font-size-smaller">Card Number
                    <span className="text-pp-primary ml-2">*</span></Form.Label>
                <div id="card-number" ref={cardRef} style={{ height: "calc(1.5em + 0.75rem + 2px)" }} />
            </Form.Group>
            <Form.Group className="mt-4">
                <Form.Label className="font-weight-bolder mb-1 pp-font-size-smaller">Expiration
                    <span className="text-pp-primary ml-2">*</span></Form.Label>
                <Form.Row>
                    <Col xs={3} md={4} lg={2}>
                        <Form.Control ref={ccMonthRef} type="input" required placeholder="MM" isInvalid={props.payment.error?.field === "month"}
                            onChange={(e) => updateMonth(e.target.value)} maxLength={2}
                            defaultValue={props.payment.month} />
                        <Form.Control.Feedback type="invalid">Month is invalid</Form.Control.Feedback>
                    </Col>
                    <Col xs={4} md={5} lg={3}>
                        <Form.Control ref={ccYearRef} type="input" required placeholder="YYYY" maxLength={4} isInvalid={props.payment.error?.field === "year"}
                            onChange={(e) => updateYear(e.target.value)}
                            defaultValue={props.payment.year} />
                        <Form.Control.Feedback type="invalid">Year is invalid</Form.Control.Feedback>
                    </Col>
                </Form.Row>
            </Form.Group>
            <Form.Group className="mt-4">
                <Form.Label className="font-weight-bolder mb-1 pp-font-size-smaller">CVV
                    <span className="text-pp-primary ml-2">*</span></Form.Label>
                <div id="card-cvv" ref={cvvRef} style={{ height: "calc(1.5em + 0.75rem + 2px)" }} />
            </Form.Group>

            <Button type="submit"
                className="mt-4"
                variant="pp-primary"
                disabled={props.disabled}>
                Submit Payment
            </Button>

        </React.Fragment>
    );
});